import { render } from "./icon-share.vue?vue&type=template&id=79968bd5"
import script from "./icon-share.vue?vue&type=script&lang=js"
export * from "./icon-share.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__